﻿import { useParams, useNavigate } from "react-router-dom";

import { CustomOption, CustomSingleValue } from "@/components/desktop/list/table/cells/SelectCell/CustomSelectComponents";
import CustomModalForm from "@/components/desktop/form/modal/CustomModalForm/CustomModalForm";
import CustomFetching from "@/components/desktop/fetching/CustomFetching";
import CustomInputSelect from "@/components/desktop/form/input/input-select/CustomInputSelect";

import { base_object } from "../specie_variety.constants";
import { useSpecieVarietyForm } from "@/hooks/maintainers/BusinessCenter/SpecieVariety/useSpecieVarietyForm";

const SpecieVarietyForm = ({ filters }) => {
	const navigate = useNavigate();
	const { option, element_id } = useParams();

	const onClose = () => {
		setFormState({ ...base_object });
		setFormErrors({});
		navigate("/configuracion/especies_variedades");
	};

	const {
		isOpen,
		modalTitle,
		isLoadingLookups,
		isLoadingSave,
		isLoadingElement,
		isFetchingElement,
		cropsOptions,
		formState,
		setFormState,
		formErrors,
		setFormErrors,
		handleSubmit,
	} = useSpecieVarietyForm({
		option,
		filters,
		elementId: element_id,
		baseObject: base_object,
		onClose,
	});

	if (!isOpen) return null;

	const isLoading = isLoadingLookups || isLoadingSave || isLoadingElement || isFetchingElement;

	return (
		<CustomModalForm open={isOpen} onClose={onClose} title={modalTitle} size="sm" asForm onSubmit={handleSubmit} isLoading={isLoading}>
			{isLoading ? (
				<CustomFetching center size="lg" />
			) : (
				<>
					<CustomInputSelect
						label="Especie"
						name="specie"
						options={cropsOptions || []}
						value={formState.specie}
						onChange={(value) => {
							setFormState((prev) => ({ ...prev, specie: value }));
							setFormErrors((prev) => ({ ...prev, specie: undefined }));
						}}
						placeholder="Escribe para buscar especie..."
						required
						col={12}
						error={formErrors.specie}
						async={true}
						creatable={true}
						components={{
							Option: CustomOption,
							SingleValue: CustomSingleValue,
						}}
					/>

					<CustomInputSelect
						label="Variedades"
						name="varieties"
						options={formState.varieties_options || []}
						value={formState.varieties}
						onChange={(value) => {
							setFormState((prev) => ({ ...prev, varieties: value }));
							setFormErrors((prev) => ({ ...prev, varieties: undefined }));
						}}
						placeholder="Seleccionar variedades"
						required
						col={12}
						error={formErrors.varieties}
						isMulti={true}
						creatable={true}
						onCreateOption={(inputValue) => {
							const newOption = { label: inputValue, value: inputValue };
							setFormState((prev) => ({
								...prev,
								varieties: [...(prev.varieties || []), inputValue],
								varieties_options: [...(prev.varieties_options || []), newOption],
							}));
						}}
					/>
				</>
			)}
		</CustomModalForm>
	);
};

export default SpecieVarietyForm;
